import { memo } from 'react';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface FlameIconProps extends IconWrapperProps {
  color?: string;
  outline?: boolean;
}

const FlameIcon = ({ color, outline, ...rest }: FlameIconProps) => (
  <IconWrapper viewBox="0 0 26 26" {...rest}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-2.000000, -2.000000)">
        <polygon points="0 0 30 0 30 30 0 30" />
        {outline ? (
          <path
            d="M12.056985,3 L12.22329,3.134535 C13.1364255,3.904455 17.455632,7.96635 16.2297945,15 C17.5563645,15.077193 20.14071,12.2292405 19.601925,8.32563 L19.70406,8.38461 C20.29506,8.74587 23.25,10.833237 23.25,16.4535285 C23.25,21.5972295 19.55664,25.5 15,25.5 C10.443609,25.5 6.75,21.408609 6.75,16.362144 C6.75,9.9789 12.5952795,8.37189 12.056985,3 Z M13.11069,6.41619 L12.958923,6.78636 C12.634551,7.528125 12.1849275,8.2818 11.606292,9.106965 L11.3062065,9.525795 L10.3311105,10.8466155 C8.8180455,12.9507855 8.25,14.31495 8.25,16.362144 C8.25,20.6125395 11.308263,24 15,24 C18.7467885,24 21.75,20.743854 21.75,16.4535285 C21.75,14.5740555 21.39657,13.067172 20.790885,11.875209 C20.005035,14.5534635 18.0991845,16.611318 16.1426565,16.4974665 C15.247893,16.4454 14.598183,15.625428 14.7520695,14.742459 C15.2926725,11.6405625 14.69883,8.99808 13.343556,6.781665 L13.11069,6.41619 Z"
            fill={color || '#D95E16'}
          />
        ) : (
          <path
            d="M12.056985,3 L12.22329,3.134535 C13.1364255,3.904455 17.455632,7.96635 16.2297945,15 C17.5563645,15.077193 20.14071,12.2292405 19.601925,8.32563 L19.70406,8.38461 C20.29506,8.74587 23.25,10.833237 23.25,16.4535285 C23.25,21.5972295 19.55664,25.5 15,25.5 C10.443609,25.5 6.75,21.408609 6.75,16.362144 C6.75,9.9789 12.5952795,8.37189 12.056985,3 Z"
            fill={color || '#D95E16'}
          />
        )}
      </g>
    </g>
  </IconWrapper>
);

export default memo(FlameIcon);
